import FilterContainer from "../Pulsar/components/Filters/FilterContainer";
import transcriptTrackController from "../Pulsar/tracks/transcripts/transcriptTrackController";
import TranscriptTooltip from "../Pulsar/tracks/transcripts/components/TranscriptTooltip";
import TranscriptsOverlay from "../Pulsar/tracks/transcripts/components/TranscriptsOverlay"; //
import TranscriptInfo from "../Pulsar/tracks/transcripts/components/TranscriptInfo";
import dnaOverlay from "../Pulsar/tracks/dna/DnaOverlay";
import dnaTrackController from "../Pulsar/tracks/dna/dnaTrackController";
import getApiClient from "../Pulsar/apiClient";
import proteinRegionsController from "../Pulsar/tracks/proteins/ProteinsController";
import selectionTrackController from "../Pulsar/tracks/selection/selectionTrackController";
import ProteinTitle from "../Pulsar/tracks/proteins/components/ProteinTitle";
import ProteinTooltip from "../Pulsar/tracks/proteins/components/ProteinTooltip";
import StructuralVariantsTitle from "../Pulsar/tracks/structural/components/StructuralVariantsTitle";
import StructuralVariantsController from "../Pulsar/tracks/structural/StructuralVariantsController";
import StructuralVariantsTooltip from "../Pulsar/tracks/structural/components/StructuralVariantsTooltip";
import StructuralOverlay from "../Pulsar/tracks/structural/components/StructuralOverlay";

function getStructuralBrowserTracks() {
  const { loadMainTranscripts, loadProteinRegions, loadSequence } =
    getApiClient();
  const maxRegionRange = 10000000;
  const maxDnaRange = 10000;
  return [
    {
      id: "dna-struct",
      title: "Dna",
      contentHeight: 25,
      pTop: 0,
      pBottom: 0,
      headerHeight: 0,
      isStickyTop: true,
      OverlayRenderer: dnaOverlay,
      controller: dnaTrackController,
      apiLoader: {
        apiFn: loadSequence,
        maxRange: maxDnaRange,
      },
    },
    {
      id: "transcript-struct",
      title: "Transcripts",
      contentHeight: 0,
      pTop: 8,
      pBottom: 8,
      FilterRenderer: FilterContainer,
      TooltipRenderer: TranscriptTooltip,
      TitleRenderer: TranscriptInfo,
      OverlayRenderer: TranscriptsOverlay,
      controller: transcriptTrackController,
      apiLoader: {
        apiFn: loadMainTranscripts,
        maxRange: Infinity,
      },
    },
    {
      id: "uniprot-struct",
      title: "UniProt Protein Regions",
      helperTextId: "UniProt Protein regions",
      contentHeight: 0,
      pTop: 5,
      pBottom: 5,
      TitleRenderer: ProteinTitle,
      TooltipRenderer: ProteinTooltip,
      controller: proteinRegionsController,
      apiLoader: {
        apiFn: loadProteinRegions,
        maxRange: maxRegionRange,
      },
    },
    {
      id: "struct-struct",
      title: "Structural Variants",
      helperTextId: "-",
      contentHeight: 0,
      pTop: 24,
      pBottom: 16,
      FilterRenderer: FilterContainer,
      TitleRenderer: StructuralVariantsTitle,
      TooltipRenderer: StructuralVariantsTooltip,
      OverlayRenderer: StructuralOverlay,
      controller: StructuralVariantsController,
      apiLoader: {
        apiFn: loadProteinRegions,
        maxRange: maxRegionRange,
      },
    },
    {
      id: "struct-btm",
      contentHeight: 400,
      headerHeight: 0,
      controller: () => ({ onReset: () => {}, meshes: [] }),
    },
    {
      id: "overlay-struct",
      title: "overlay",
      headerHeight: 0,
      isOverlay: true,
      contentHeight: 1000,
      pTop: 0,
      pBottom: 0,
      controller: selectionTrackController,
    },
  ];
}

export default getStructuralBrowserTracks;
